import Antd from 'ant-design-vue'
import 'normalize.css/normalize.css'
import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/base.less'
import 'virtual:svg-icons-register'
import SvgIcon from './components/SvgIcon/index.vue'
import routers from './router'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { loading } from './components/Loading'
import './permission'
import hljs from 'highlight.js'
import 'highlight.js/styles/atom-one-dark.css' //样式
// import print from 'vue3-print-nb'

const app = createApp(App)
const pinia = createPinia()
// pinia 持久化插件
pinia.use(piniaPluginPersistedstate)

app.use(Antd)
app.use(routers)
app.use(pinia)
app.use(loading)

//创建v-highlight全局指令
app.directive('highlight', function (el) {
    let blocks = el.querySelectorAll('pre code')
    blocks.forEach(block => {
        hljs.highlightBlock(block)
    })
})

// app.use(print)

// vue3CurstomDirective(app)

app.component('SvgIcon', SvgIcon)

// 用于调整是否移除模板中的 HTML 注释。
app.config.compilerOptions.comments = true
app.mount('#app')
